// @ts-nocheck

import { match as MatchStateUtils } from '..';
import { DefaultVisibleSetsNumbers } from '../../constants/scoreboards';
import type { ScoreboardProps, SecondariesScoreType } from '../../states/scoreboards';

export const computeMainScore = (scores: Array<string>): Array<string> => {
  return [...scores].pop().split(':');
};

export const computeSecondaryScores = (scores: Array<string>, isEnded: boolean): SecondariesScoreType => {
  const finalScores = [];
  const slicedScores = scores.length > 1 ? (isEnded ? scores : scores.slice(0, scores.length - 1)) : [];

  slicedScores.map((score) => {
    return finalScores.push({
      score: score.split(':'),
    });
  });

  return finalScores;
};

export default (
  {
    sportId,
    matchId,
    period,
    periodName,
    setScores,
    competitor1Name,
    competitor2Name,
    competitor1Flag,
    competitor2Flag,
    server,
  }: unknown,
  fromBetBuilder: boolean,
  isEnded: boolean,
): ScoreboardProps => {
  let scores = null;

  if (setScores && setScores !== '') {
    scores = setScores.split(' - ');
  }

  return {
    matchId,
    period: periodName || MatchStateUtils.statusMatchBySport(sportId, period),
    competitors: [
      {
        name: competitor1Name,
        flag: competitor1Flag,
        isServing: server === 1,
      },
      {
        name: competitor2Name,
        flag: competitor2Flag,
        isServing: server === 2,
      },
    ],
    scores: {
      main: {
        score: scores && !isEnded ? computeMainScore(scores) : ['', ''],
      },
      secondaries: scores ? computeSecondaryScores(scores, isEnded) : [],
    },
    disableHighlightLastSet: true,
    defaultVisibleSetsNumber: DefaultVisibleSetsNumbers.LAST_SET_AS_GAME_SCORE,
  };
};
